import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getCurrentProjectIdentifier } from '@neptune/current-project-business-logic';
import { getLastNotificationTimestamp } from '@neptune/shared/leaderboard-business-logic';

import { fetchLeaderboardCount } from 'state/project-leaderboard/lb-count/actions';
import { getLeaderboardCountState } from 'state/project-leaderboard/lb-count/selectors';

const selectLastNotificationTimestamp = (state: any) => getLastNotificationTimestamp(state, 'runs');

export const useLbCount = () => {
  const dispatch = useDispatch();

  const lastNotificationTimeStamp = useSelector(selectLastNotificationTimestamp);
  const projectIdentifier = useSelector(getCurrentProjectIdentifier);
  const { totalCount } = useSelector(getLeaderboardCountState);

  const isInitialized = React.useRef(false);
  const isEmptyRef = React.useRef(!totalCount);

  React.useEffect(() => {
    isEmptyRef.current = !totalCount;
  }, [totalCount]);

  React.useEffect(() => {
    if (isInitialized.current && !isEmptyRef.current) {
      return;
    }

    isInitialized.current = true;

    dispatch(fetchLeaderboardCount({ projectIdentifier }));
  }, [dispatch, projectIdentifier, lastNotificationTimeStamp]);
};
